import { useOS } from '@/app/hooks/useOS'
import { useEffect } from 'react'

export const AppEquipes = () => {
  const { isIOS, isAndroid, isOther } = useOS()

  useEffect(() => {
    if (isIOS) window.location.href = import.meta.env.VITE_TEAMS_APPLE_URL
    else if (isAndroid || isOther)
      window.location.href = import.meta.env.VITE_TEAMS_GOOGLE_URL
  }, [isAndroid, isIOS, isOther])

  return <></>
}
